import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  checkbox: {
    '& .MuiTypography-body1': {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 600,
      position: 'relative',
      top: -4,
    },
  },
  checkboxSubText: {
    display: 'block',
    paddingLeft: 36,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral600,
    position: 'relative',
    top: -4,
  },
});
